import { http } from '@/utils/http';

export interface ICompanyDetail {
  exhibitionHallCode?: string;
  boothCode?: string;
  exhibitorId?: number;
  contract?: string;
  name?: string;
  enName?: string;
  brandName?: string;
  brandEnName?: string;
  logo?: string;
  description?: string;
  enDescription?: string;
  country?: string;
  province?: string;
  city?: string;
  district?: string;
  address?: string;
  enAddress?: string;
  tel?: string;
  email?: string;
  fax?: string;
  website?: string;
  videoUrl?: string;
  category?: string;
  mainBusi?: any;
  contactMobile?: string;
  contactName?: string;
}

export interface IExhibitorDetailBrandVoList {
  brandId?: string;
  exhibitorId?: string;
  brandName?: string;
  brandOriginRegion?: string;
}

export interface IExhibitorDetailDealerVoList {
  dealerId?: string;
  exhibitorId?: string;
  companyNameZh?: string;
  companyNameEn?: string;
  addressZh?: string;
  addressEn?: string;
  companyPhone?: string;
  companyUrl?: string;
}

/** 公司信息详情 */
export const getCompanyDetail = () => {
  return http.post<unknown, ICompanyDetail>('/busi/exhibitor/info');
};

export interface IExhibitorDetailBody {
  companyNameZh?: string;
  companyNameEn?: string;
  countryZh?: string;
  cityZh?: string;
  marketZh?: string;
  addressDetailZh?: string;
  countryEn?: string;
  cityEn?: string;
  marketEn?: string;
  addressDetailEn?: string;
  companyPhone?: string;
  companyEmail?: string;
  companyUrl?: string;
  companyNature?: boolean;
  companyIntroduceZh?: string;
  companyIntroduceEn?: string;
  mainProductCategoriesTags?: string;
  type?: number;
  name?: string;
  tel?: string;
  brandVoList?: IExhibitorDetailBodyBrandVoList[];
  dealerVoList?: IExhibitorDetailBodyDealerVoList[];
  companyLogo?: '';
}

export interface IExhibitorDetailBodyBrandVoList {
  brandName?: string;
  brandOriginRegion?: string;
}

export interface IExhibitorDetailBodyDealerVoList {
  companyNameZh?: string;
  companyNameEn?: string;
  addressZh?: string;
  addressEn?: string;
  companyPhone?: string;
  companyUrl?: string;
}

export const updateCompanyDetail = (body: IExhibitorDetailBody) => {
  return http.post<void>('/busi/exhibitor/update', body);
};

export interface IMainProductItem {
  code: string;
  name?: string;
  children: IMainProductItem[];
}

export const getMainProductCategoriesTags = () => {
  return http.post<unknown, IMainProductItem[]>(
    '/busi/dict/data/Exhibitor_Main_Busi',
  );
};

export const getMainProductCategoriesTagsEn = () => {
  return http.post<unknown, IMainProductItem[]>(
    '/busi/dict/data/Exhibitor_Main_Busi_En',
  );
};

export const getCompanyType = () => {
  return http.post<unknown, IMainProductItem[]>(
    '/busi/dict/data/Exhibitor_Business_Type',
  );
};

export interface IListResp {
  rows?: IList[];
  total?: number;
  size?: number;
  current?: number;
  pages?: number;
}

export interface IList {
  id?: number;
  productName?: string;
  productNameEn?: string;
  thumbnail?: any;
  banner?: any;
  content?: string;
  contentEn?: string;
  category?: any;
  status?: number;
  country?: string;
  province?: string;
  top?: string;
  suncode?: string;
  addressInfo?: {
    country?: string;
    province?: string;
  };
}
export const getProductList = (query: {
  page: number;
  size: number;
  productName?: string;
  auditStatus?: string;
  staus?: string;
}) => {
  const { page: pageNum, size: pageSize, ...body } = query;
  return http.post<unknown, IListResp>('/busi/product/list', body, {
    params: {
      pageNum,
      pageSize,
    },
  });
};

export const addProduct = data => {
  return http.post<unknown, any>('/busi/product/add', data);
};

export const updateProduct = data => {
  const { auditStatus, id, ...rest } = data;
  return http.post<unknown, any>(
    `/busi/product/update/${auditStatus}/${id}`,
    rest,
  );
};

export const updateProductStatus = (id, status) => {
  return http.post<unknown, any>(`/busi/product/status/${id}/${status}`);
};

export const updateProductTop = (id, top) => {
  return http.post<unknown, any>(`/busi/product/top/${id}/${top}`);
};

export const getProductCount = () => {
  return http.post<
    unknown,
    {
      auditFail: number;
      auditSuccess: number;
      audtiWait: number;
    }
  >('/busi/product/count', {});
};
